
const Util = {
  /**
   * 判断是否是在app中打开
   */
  isInApp() {
    let ua = navigator.userAgent;
    if (ua.indexOf('chuangqi') != -1) {
      return true;
    }
    return false;
  },
  
  /**
   * 时间戳的插值转换为时分秒格式
   */
  timeStampTurn(end, start) {
    let timeDiff = end  - start;
    let days = parseInt(timeDiff / (1000 * 60 * 60 * 24));
    let hours = parseInt((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = parseInt((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = parseInt((timeDiff % (1000 * 60)) / 1000);
    if(days < 1) {
      days = ['0', '0'];
    }else if(days >= 1 && days < 10) {
      days = ['0', '' + days]
    }else {
      days = ('' + days).match(/.{1}/g);
    }

    if(hours < 1) {
      hours = ['0', '0'];
    }else if(hours >= 1 && hours < 10) {
      hours = ['0', '' + hours]
    }else {
      hours = ('' + hours).match(/.{1}/g);
    }

    if(minutes < 1) {
      minutes = ['0', '0'];
    }else if(minutes >= 1 && minutes < 10) {
      minutes = ['0', '' + minutes]
    }else {
      minutes = ('' + minutes).match(/.{1}/g);
    }

    if(seconds < 1) {
      seconds = ['0', '0'];
    }else if(seconds >= 1 && seconds < 10) {
      seconds = ['0', '' + seconds]
    }else {
      seconds = ('' + seconds).match(/.{1}/g);
    }

    return {days, hours, minutes, seconds}
  }
}

export default Util;
